module.exports = __webpack_public_path__ + "img/cr.8641e922.svg";